module.exports = __webpack_public_path__ + "img/47.43539900.svg";